import { render, staticRenderFns } from "./FormFolder.vue?vue&type=template&id=38beab1b"
import script from "./FormFolder.vue?vue&type=script&lang=js"
export * from "./FormFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports